import classNames from "classnames";
import "styles/atoms/hr.css"

const prefix = "a-hr";

const Hr = ({ className, content }) => {
  let classForComponent = classNames(prefix, "text-center", {
    [className]: className
  });

  return(
    <div className={classForComponent}>
      <span className="text-gray-600 text-1xl mt-[-0.9rem]">{content}</span>
    </div>
  )
};

export default Hr;
